
import React, { useEffect, useState } from "react";
import "./ComingSoon.css";
import logo from "../logo.png"

const ComingSoon: React.FC = () => {

    return (
        <div className="ozonit-coming-soon">

            {/* Background */}
            <div className="ozonit-background">
                <div className="ozonit-grid" />

                <div className="ozonit-glow ozonit-glow-one" />
                <div className="ozonit-glow ozonit-glow-two" />

                <div className="ozonit-orb ozonit-orb-one" />
                <div className="ozonit-orb ozonit-orb-two" />
            </div>

            {/* Navigation */}
            <header className="ozonit-header">
                <div className="ozonit-logo">
                    <img src={logo} style={{ width: '240px' }} alt="logo" />
                    {/* Ozo<span>NIT</span> */}
                </div>

                <div className="ozonit-status">
                    <span />
                    Website Under Development
                </div>
            </header>

            {/* Main */}
            <main className="ozonit-main">

                <section className="ozonit-content">

                    {/* Small heading */}
                    <div className="ozonit-eyebrow">
                        <span className="eyebrow-line" />
                        INNOVATION IS COMING
                        <span className="eyebrow-line" />
                    </div>

                    {/* Main heading */}
                    <h1>
                        Proactive and Preventive Solution for addressing
                        <span className="second">Tribal Children Welfare.</span>
                    </h1>

                    {/* Description */}
                    <p className="ozonit-description">
                        OZONIT is building preventive solutions for welfare of children and elders
                        Our website will be launching soon
                    </p>

                </section>

                {/* Right visual */}
                <section className="ozonit-visual">
                    <div className="visual-ring visual-ring-one" />
                    <div className="visual-ring visual-ring-two" />
                    <div className="visual-ring visual-ring-three" />
                    <div className="visual-center">
                        <div className="visual-logo">
                            O
                        </div>
                        <div className="visual-line" />
                        <div className="visual-text">
                            <strong>OZONIT</strong>
                            <span>Technology • Innovation</span>
                        </div>

                    </div>

                    <div className="floating-card floating-card-one">
                        <span className="card-icon">✦</span>
                        <div>
                            <strong>Innovation</strong>
                            <small>Building the future</small>
                        </div>
                    </div>

                    <div className="floating-card floating-card-two">
                        <span className="card-icon">⌁</span>
                        <div>
                            <strong>Technology</strong>
                            <small>Digital solutions</small>
                        </div>
                    </div>

                </section>

            </main>

            {/* Footer */}
            <footer className="ozonit-footer">

                <span>
                    © {new Date().getFullYear()} ozonit.in
                </span>

                <span className="footer-divider" />

                <span>
                    All rights reserved.
                </span>

            </footer>

        </div>
    );
};

export default ComingSoon;